module.exports = __webpack_public_path__ + "static/media/profile-cross.83a061ba.svg";